<script>
import appConfig from '@/app.config'
import { notificationMethods } from '@/state/helpers'
import notifChannel from '@/helpers/notif-channel'
import WidgetCall2Way from './router/views/two-way-communication/index.vue'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import * as identityApi from '@/services/rest-api-identity/lib/oauth/token'
import NotificationContainer from '@/components/Notification/NotificationContainer.vue' // ✅ TAMBAH INI
import { Helper } from '@/mixin/helper'
import * as notificationApi from '@/services/rest-api-sms/lib/notification/notification'

const soundNotification = require('@/assets/sounds/notification_sound_websms.mp3')

export default {
  name: 'app',

  page: {
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },

  mixins: [Helper],

  components: {
    WidgetCall2Way,
    NotificationContainer, // ✅ TAMBAH INI
  },

  data() {
    return {
      scTimer: 0,
      scY: 0,
    }
  },

  async mounted() {
    notifChannel.onmessage = (event) => {
      const { type, id } = event.data

      if (type === 'SYNC_CLOSE_NOTIF') {
        this.$refs.notificationContainer?.removeNotification(id, false)
      }
    }

    const userId = this.getUserId()
    try {
      // ✅ Fetch dependencies
      await this.$store.dispatch('identity/getFeatureFlag')

      const flag = await this.$store.getters['identity/getFeatureFlagData']('notification')

      if (!flag) {
        console.warn('Feature flag "notification" not found')
        return
      }

      const isNotificationActive = await this.$store.getters['identity/getFeatureFlagValue']('notification') ?? false
      const hasNotificationAccess = await this.$store.getters['identity/hasAccess'](['sms-notification:read']) ?? false
      
      if (isNotificationActive && hasNotificationAccess) {
        await Promise.all([
          this.$store.dispatch('users/fetchUser', userId),
          await this.$store.dispatch('notification/fetchNotificationRule'),
        ])

        // Initialize FCM
        await this.initFCM()
      }
    } catch (error) {
      console.error('❌ Error in FCM setup:', error)
    }
    this.initScriptVssHowen()
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.clearNotification()
    },
  },

  methods: {
    async initFCM() {
      const config = {
        apiKey: process.env.VUE_APP_NOTIF_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_NOTIF_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.VUE_APP_NOTIF_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_NOTIF_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_NOTIF_FIREBASE_MESSAGE_ID,
        appId: process.env.VUE_APP_NOTIF_FIREBASE_APP_ID,
        measurementId: process.env.VUE_APP_NOTIF_FIREBASE_MEASUREMENT_ID,
      }

      const firebaseApp = initializeApp(config, 'vsmsNotif')
      const messaging = getMessaging(firebaseApp)

      await Notification.requestPermission()

      const token = await getToken(messaging, {
        vapidKey: 'BJWUpIU_lc4VbNHBSS7Hg4KDGcZxWiaHdFQIy0t3XOYRTRsqpXTb6DR6yooVhvNPScRFPVzoX28CxQV89cvFtRM',
      }).catch((err) => {
        console.error('Error getting FCM token:', err)
        return null
      })

      let platform = 'websms'
      console.log("TEST env", process.env.NODE_ENV)
      if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'release') {
        platform = platform + '-stg'
      } else if (process.env.NODE_ENV === 'development') {
        platform = platform + '-dev'
      }

      if (token) {
        try {
          await identityApi.updateFcm({ fcm_token: token, platform: platform })
        } catch (err) {
          console.error('Error updating FCM token:', err)
        }
      }

      console.log("Messaging initialized")

      onMessage(messaging, async (payload) => {
        console.log("📩 MESSAGE MASUK:", payload)

        const user = this.$store.state.users.user
        const data = payload.data || {}

        // Fetch notification rule
        let rule = null
        try {
          const ruleResponse = await notificationApi.getNotificationRule()
          if (ruleResponse.status) rule = ruleResponse.data
        } catch (err) {
          console.error('Error fetching notification rule:', err)
          return
        }

        if (!rule) {
          console.error('Notification rule not found')
          return
        }

        // If Notification is from Workorder
        if (data?.wo_number) {
          const isTechnician =
            Number(user?.position_id ?? '0') === Number(process.env.VUE_APP_TECHNICIAN_POSITION_ID)
          const isEnabled = isTechnician ? rule.is_enabled : rule.wo_status_change_enabled
          console.log(isEnabled)
          if (!isEnabled) return
        }

        console.log("heheheh", rule)

        const title = payload.notification?.title || data.title
        const body  = payload.notification?.body  || data.message
        const notification_id = Number(data.notification_id ?? 0)

        if (notification_id > 0) {
          this.$store.commit('notification/ADD_NOTIFICATION', {
            notification_id: notification_id,
            name:            title,
            description:     body,
            username:        data.user_name,
            wo_number:       data.wo_number,
            is_read:         data.is_read === 'true',
            created_at:      new Date(new Date(data.created_at).getTime() + 7 * 60 * 60 * 1000),
          })

          if (rule.is_sound_enabled) {
            new Audio(soundNotification).play().catch(() => {})
          }
        }

        if (rule.is_pop_up_enabled && notification_id > 0) {
          this.$refs.notificationContainer.addNotification({
            subject:         title,
            message:         body,
            technician:      data.user_name,
            wo_number:       data?.wo_number,
            notification_id: notification_id,
            duration:        10000,
            autoClose:       true,
          })
        }
      })
    },

    // ✅ METHOD: Handle dismiss
    onDismissNotification(notification) {
      console.log('Notification dismissed:', notification)
    },

    // ✅ METHOD: Handle view details
    async onViewNotificationDetails(notification) {
      console.log('View notification details:', notification)

      if (!notification.wo_number) return

      if (!notification.is_read) {
        this.$store.dispatch(
          'notification/markNotificationRead',
          notification.notification_id
        )
      }

      // this.$router.push({
      //   path: '/work-order/validation',
      //   query: {
      //     wo: notification.wo_number,
      //     t: Date.now()
      //   }
      // })
      this.$router.push({
        path: '/work-order/validation/form/'+notification.wo_number,
      })
    },

    clearNotification: notificationMethods.clear,

    handleScroll: function () {
      if (this.scTimer) return
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY
        clearTimeout(this.scTimer)
        this.scTimer = 0
      }, 100)
    },

    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    async initScriptVssHowen() {
      const src = [
        'common.js',
        'webgl.js',
        'vss-player.js',
        'HWRecorder.js',
        'pcm-player.js',
        'HWMediaPlayer.js',
      ]

      for (let i = 0; i < src.length; i++) {
        this.loadScriptVssHowen(src[i])
      }
    },

    loadScriptVssHowen(filename) {
      return new Promise((resolve, reject) => {
        const src = `/vss/${filename}`
        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
  },
}
</script>

<template>
  <div id="app">
    <RouterView />

    <!-- ✅ NOTIFICATION CONTAINER (BUILT-IN STACK MANAGEMENT) -->
    <NotificationContainer ref="notificationContainer" @dismiss="onDismissNotification"
      @view-details="onViewNotificationDetails" />

    <span id="pagetop" class="mc-totop" @click="toTop" v-show="scY > 300">
      <i class="mc-fa icon-outline_arrow-ios-up"></i>
    </span>
    <WidgetCall2Way />
    <ErrorDescriptionModalGlobal />   <!-- TAMBAHKAN INI -->
  </div>
</template>